//
// Autogenerated by Thrift Compiler (0.6.0-en-exported)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;
  var AuthenticationErrors = require('./AuthenticationErrors');


  module.exports.Result = {
    'SUCCESS' : 1,
    'FAILURE' : 2,
    'UNKNOWN_OPENID' : 3,
    'USER_EXISTS' : 4
  };

  module.exports.ServiceProvider = {
    'GOOGLE' : 0
  };

  module.exports.OpenIdCredential = Thrift.Struct.define('OpenIdCredential',  {
    1: { alias: 'openIdToken', type: Thrift.Type.STRING },
    2: { alias: 'serviceProvider', type: Thrift.Type.I32 }
  });

  module.exports.PlainCredential = Thrift.Struct.define('PlainCredential',  {
    1: { alias: 'userId', type: Thrift.Type.I32 },
    2: { alias: 'password', type: Thrift.Type.STRING }
  });

  module.exports.AuthenticationRequestResult = Thrift.Struct.define('AuthenticationRequestResult',  {
    1: { alias: 'userId', type: Thrift.Type.I32 },
    2: { alias: 'userEmail', type: Thrift.Type.STRING },
    3: { alias: 'result', type: Thrift.Type.I32 }
  });

  module.exports.RegistrationRequestResult = Thrift.Struct.define('RegistrationRequestResult',  {
    1: { alias: 'refreshToken', type: Thrift.Type.STRING },
    2: { alias: 'userEmail', type: Thrift.Type.STRING },
    3: { alias: 'result', type: Thrift.Type.I32 }
  });

  var AuthenticationService = module.exports.AuthenticationService = {};

  AuthenticationService.authenticate = Thrift.Method.define({
    alias: 'authenticate',
    args: Thrift.Struct.define('authenticateArgs', {
      1: { alias: 'credential', type: Thrift.Type.STRUCT, def: module.exports.PlainCredential, index: 0 }
    }),
    result: Thrift.Struct.define('authenticateResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationRequestResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.UserNotFoundException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException }
    })
  });

  AuthenticationService.authenticateOpenID = Thrift.Method.define({
    alias: 'authenticateOpenID',
    args: Thrift.Struct.define('authenticateOpenIDArgs', {
      1: { alias: 'credential', type: Thrift.Type.STRUCT, def: module.exports.OpenIdCredential, index: 0 }
    }),
    result: Thrift.Struct.define('authenticateOpenIDResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationRequestResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.UserNotFoundException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException },
      3: { alias: 'formatException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.BadOpenIDException }
    })
  });

  AuthenticationService.registerUser = Thrift.Method.define({
    alias: 'registerUser',
    args: Thrift.Struct.define('registerUserArgs', {
      1: { alias: 'credential', type: Thrift.Type.STRUCT, def: module.exports.PlainCredential, index: 0 }
    }),
    result: Thrift.Struct.define('registerUserResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.RegistrationRequestResult },
      1: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException }
    })
  });

  AuthenticationService.registerOpenIdUser = Thrift.Method.define({
    alias: 'registerOpenIdUser',
    args: Thrift.Struct.define('registerOpenIdUserArgs', {
      1: { alias: 'userId', type: Thrift.Type.I32, index: 0 },
      2: { alias: 'credential', type: Thrift.Type.STRUCT, def: module.exports.OpenIdCredential, index: 1 }
    }),
    result: Thrift.Struct.define('registerOpenIdUserResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.RegistrationRequestResult },
      1: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException },
      2: { alias: 'formatException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.BadOpenIDException }
    })
  });

  AuthenticationService.associateOpenIDWithUser = Thrift.Method.define({
    alias: 'associateOpenIDWithUser',
    args: Thrift.Struct.define('associateOpenIDWithUserArgs', {
      1: { alias: 'credential', type: Thrift.Type.STRUCT, def: module.exports.OpenIdCredential, index: 0 },
      2: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 1 }
    }),
    result: Thrift.Struct.define('associateOpenIDWithUserResult', {
      1: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException },
      2: { alias: 'formatException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.BadOpenIDException },
      3: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.UserNotFoundException }
    })
  });

  AuthenticationService.dissociateOpenIDFromUser = Thrift.Method.define({
    alias: 'dissociateOpenIDFromUser',
    args: Thrift.Struct.define('dissociateOpenIDFromUserArgs', {
      1: { alias: 'credential', type: Thrift.Type.STRUCT, def: module.exports.OpenIdCredential, index: 0 },
      2: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 1 }
    }),
    result: Thrift.Struct.define('dissociateOpenIDFromUserResult', {
      1: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException },
      2: { alias: 'formatException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.BadOpenIDException },
      3: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.UserNotFoundException }
    })
  });

  AuthenticationService.updatePassword = Thrift.Method.define({
    alias: 'updatePassword',
    args: Thrift.Struct.define('updatePasswordArgs', {
      1: { alias: 'userId', type: Thrift.Type.I32, index: 0 },
      2: { alias: 'oldPassword', type: Thrift.Type.STRING, index: 1 },
      3: { alias: 'newPassword', type: Thrift.Type.STRING, index: 2 }
    }),
    result: Thrift.Struct.define('updatePasswordResult', {
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.UserNotFoundException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: AuthenticationErrors.SystemException }
    })
  });

  // Define AuthenticationService Client

  function AuthenticationServiceClient(output) {
    this.output = output;
    this.seqid = 0;
  }

  AuthenticationServiceClient.prototype.authenticate = function(credential, callback) {
    var mdef = AuthenticationService.authenticate;
    var args = new mdef.args();
    args.credential = credential;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  AuthenticationServiceClient.prototype.authenticateOpenID = function(credential, callback) {
    var mdef = AuthenticationService.authenticateOpenID;
    var args = new mdef.args();
    args.credential = credential;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  AuthenticationServiceClient.prototype.registerUser = function(credential, callback) {
    var mdef = AuthenticationService.registerUser;
    var args = new mdef.args();
    args.credential = credential;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  AuthenticationServiceClient.prototype.registerOpenIdUser = function(userId, credential, callback) {
    var mdef = AuthenticationService.registerOpenIdUser;
    var args = new mdef.args();
    args.userId = userId;
    args.credential = credential;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  AuthenticationServiceClient.prototype.associateOpenIDWithUser = function(credential, authenticationToken, callback) {
    var mdef = AuthenticationService.associateOpenIDWithUser;
    var args = new mdef.args();
    args.credential = credential;
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  AuthenticationServiceClient.prototype.dissociateOpenIDFromUser = function(credential, authenticationToken, callback) {
    var mdef = AuthenticationService.dissociateOpenIDFromUser;
    var args = new mdef.args();
    args.credential = credential;
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  AuthenticationServiceClient.prototype.updatePassword = function(userId, oldPassword, newPassword, callback) {
    var mdef = AuthenticationService.updatePassword;
    var args = new mdef.args();
    args.userId = userId;
    args.oldPassword = oldPassword;
    args.newPassword = newPassword;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  module.exports.AuthenticationService.Client = AuthenticationServiceClient;

  // Define AuthenticationService Server

  function AuthenticationServiceServer(service, stransport, Protocol) {
    var methodName;
      this.service = service;
      this.stransport = stransport;
      this.processor = new Thrift.Processor();
      for (methodName in AuthenticationService) {
        if (service[methodName]) {
          this.processor.addMethod(AuthenticationService[methodName], service[methodName].bind(service));
        }
      }
      this.stransport.process = function (input, output, noop) {
      var inprot = new Protocol(input);
      var outprot = new Protocol(output);
      this.processor.process(inprot, outprot, noop);
    }.bind(this);
  }

  AuthenticationServiceServer.prototype.start = function () {
    this.stransport.listen();
  };
  AuthenticationServiceServer.prototype.stop = function () {
    this.stransport.close();
  };

  module.exports.AuthenticationService.Server = AuthenticationServiceServer;

